import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { UnidataTable } from '~/components';

import { recordFiltering } from '~/store/modules/operacaoconsultalogliberacaosiad/actions';

import { format, setHours, setMinutes, setSeconds, parseISO } from 'date-fns';

function OperacaoConsultaLogLiberacaoSiad() {
  const operacaoconsultalogliberacaosiad = useSelector(
    (state) => state.operacaoconsultalogliberacaosiad
  );

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'loli_datahora_inicio',
        label: 'Início',
        formatted: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      },
      {
        id: 'loli_datahora_fim',
        label: 'Fim',
        formatted: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      },
      {
        id: 'tempo_resposta',
        label: 'Tempo Resposta',
        align: 'left',
      },
      {
        id: 'poco_descricao',
        label: 'Posto',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'bico_numero',
        label: 'Bico',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'veic_placa_apresentacao',
        label: 'Veículo',
        filter: {
          type: 'text',
        },
        align: 'left',
      },

      {
        id: 'loli_num_tentativas_ws',
        label: 'Número Tentativas',
        align: 'right',
      },
      {
        id: 'desc_loli_modo',
        label: 'Liberado Sistema',
        filter: {
          type: 'text',
        },
        align: 'left',
      },

      {
        id: 'desc_loli_status_atendimento_liberado_ws',
        label: 'Status Atendimento',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'loli_msg',
        label: 'Mensagem',
        align: 'right',
      },
    ],
    []
  );

  const filter = useMemo(
    () => [
      {
        id: 'data_cadastro_ini',
        label: ' Inicial',
        type: 'initialdatetime',
        defaultValue: datahorainicial,
      },
      {
        id: 'data_cadastro_fim',
        label: 'Final',
        type: 'finaldatetime',
        defaultValue: datahorafinal,
      },
    ],
    [datahorainicial, datahorafinal]
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="loli_datahora_inicio ASC"
        title={'Consulta Liberação Interface SIAD'}
        create={false}
        delete={false}
        update={false}
        fixed
        header={header}
        custom={filter}
        redux={operacaoconsultalogliberacaosiad}
        read={recordFiltering}
        detach="loli_codigo"
        keys="loli_codigo"
        view="VW_TB_LOG_LIBERACAO_SIAD"
        reportTitle="Consulta Liberação Interface SIAD"
      />
    </>
  );
}

export default OperacaoConsultaLogLiberacaoSiad;
